export default () => ({
	click() {
		let quoteButton = document.getElementById("wrapper");

		if (quoteButton) {
			quoteButton.scrollIntoView({
				behavior: "smooth",
			});
		}
	},
});
